import clsx from 'clsx';
import { TextLink } from '@mosey/components/navigation/TextLink';
import { useIsPlatformUser, usePlatform } from '../../../hooks/useUser';
import { useIsStandaloneRoute, useResolverFinishUrl } from '../utils/hooks';

interface StandaloneTaskPlatformReturnLinkProps {
  leftAlign?: boolean;
}

export const StandaloneTaskPlatformReturnLink = ({
  leftAlign = false,
}: StandaloneTaskPlatformReturnLinkProps) => {
  const isPlatformUser = useIsPlatformUser();
  const platform = usePlatform();
  const isStandaloneRoute = useIsStandaloneRoute();
  const resolverFinishUrl = useResolverFinishUrl();

  if (isStandaloneRoute && isPlatformUser) {
    return (
      <div className={clsx(leftAlign && 'mr-auto shrink-0')}>
        <TextLink
          to={resolverFinishUrl}
          variant="secondary"
          state={{ fullWidthPlatformAppChrome: true }}
        >
          {platform ? `Return to ${platform.name}` : 'Finish'}
        </TextLink>
      </div>
    );
  }

  return null;
};
